export const campaignStatus = {
    SCHEDULED: {
        key: "SCHEDULED",
        label: "Agendado",
        color: "#ee8200"
    },
    SENDED: {
        key: 'SENDED',
        label: 'Enviado',
        color: "#4CAF50"
    },
    SENT: {
        key: 'SENT',
        label: 'Enviado',
        color: "#4CAF50"
    },
    CANCELED: {
        key: 'CANCELED',
        label: 'Cancelado',
        color: "#F44336"
    },
    FAILED: {
        key: 'FAILED',
        label: 'Falha',
        color: "#F44336"
    },
    ARCHIEVED: {
        key: 'ARCHIEVED',
        label: 'Arquivado',
        color: "#9E9E9E"
    },
    PROCESSING: {
        key: 'PROCESSING',
        label: 'Processando',
        color: "#2196F3"
    },
    FROZEN: {
        key: 'FROZEN',
        label: 'Congelado',
        color: "#00BCD4"
    }
}

const sendingCost = {
    value: 0.0001
}

export default {
    campaignStatus,
    sendingCost
};